import { LocationGroup } from '@/routing/location-group'
import Cookies from 'js-cookie'
import { Route } from 'vue-router'

/**
 * ユーザーに購入の意志があることをcookieに記録する
 * これは高負荷時に購入の意志のあるユーザーとそうでないユーザーを識別するために利用する
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/8538
 */
export function setPurchaseIntentCookie(to: Route): void {
  // LocationGroupStoreを使っていないのは、setLocationGroups hookとの実行の前後関係を意識したくないため
  const locationGroups: LocationGroup[] = to.meta
    ? to.meta.locationGroups || []
    : []

  if (locationGroups.includes('cart') || locationGroups.includes('order')) {
    // tslint:disable-next-line:no-magic-numbers
    const expireDays = 1 / 24 // 1時間 = 1/24日
    Cookies.set('purchaseIntent', '1', { expires: expireDays })
  }
}
